import ExportBulkProductOverlay from './ExportBulkProductOverlay';
import ImportBulkProductOverlay from './ImportBulkProductOverlay';

const BulkProductOverlay = ({ disabledExport, disabledImport }) => {
  return (
    <>
      <ExportBulkProductOverlay disabled={disabledExport} />
      <ImportBulkProductOverlay disabled={disabledImport} />
    </>
  );
};

export default BulkProductOverlay;
